import { RandomEffector as _RandomEffector } from "./core";
import { RadialCloner as _RadialCloner } from "./radialCloner";
import { MatrixCloner as _MatrixCloner } from "./matrixCloner";
import { LinearCloner as _LinearCloner } from "./linearCloner";
import { ObjectCloner as _ObjectCloner } from "./objectCloner";

export const ClonerSystem = {
    RandomEffector: _RandomEffector,
    RadialCloner: _RadialCloner,
    MatrixCloner: _MatrixCloner,
    LinearCloner: _LinearCloner,
    ObjectCloner: _ObjectCloner,
};

export const RandomEffector = _RandomEffector;
export const RadialCloner = _RadialCloner;
export const MatrixCloner = _MatrixCloner;
export const LinearCloner = _LinearCloner;
export const ObjectCloner = _ObjectCloner;
